import React from 'react';
import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { formatShortDate, formatCurrency, formatNumber } from '../utils/formatters';
import { COLORS, tooltipStyle } from '../theme';

// Evolução diária: Gasto (barras, eixo esq) + Conversas iniciadas (linha verde, eixo dir).
const PerformanceChart = ({ data, currency = 'BRL' }) => {
  const chartData = data.map(item => ({
    date: formatShortDate(item.date),
    spend: parseFloat(item.spend || 0),
    conversations: item.conversations
  }));

  return (
    <div className="chart-card chart-full">
      <h3 className="chart-title">Evolução diária</h3>
      <ResponsiveContainer width="100%" height={320}>
        <ComposedChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={COLORS.border} vertical={false} />
          <XAxis dataKey="date" stroke={COLORS.muted} tick={{ fill: COLORS.muted, fontSize: 12 }} />
          <YAxis
            yAxisId="left"
            stroke={COLORS.muted}
            tick={{ fill: COLORS.muted, fontSize: 12 }}
            tickFormatter={(v) => formatCurrency(v, currency)}
            width={80}
          />
          <YAxis
            yAxisId="right"
            orientation="right"
            stroke={COLORS.muted}
            tick={{ fill: COLORS.muted, fontSize: 12 }}
          />
          <Tooltip
            {...tooltipStyle}
            cursor={{ fill: 'rgba(255,255,255,0.04)' }}
            formatter={(value, name) =>
              name === 'Gasto' ? formatCurrency(value, currency) : formatNumber(value)
            }
          />
          <Legend />
          <Bar
            yAxisId="left"
            dataKey="spend"
            name="Gasto"
            fill={COLORS.accent}
            radius={[4, 4, 0, 0]}
            maxBarSize={36}
            isAnimationActive={false}
          />
          <Line
            yAxisId="right"
            type="monotone"
            dataKey="conversations"
            name="Conversas iniciadas"
            stroke={COLORS.conversas}
            strokeWidth={2.5}
            dot={false}
            activeDot={{ r: 5 }}
            isAnimationActive={false}
          />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PerformanceChart;
